// routes
import License from '../views/License';
import LicenseDetailTabs from '../views/LicenseDetailTabs';
import CitationDetailTabs from '../views/CitationDetailTabs';
import LicenseFilters from '../views/License/LicenseFilters';
import PersonDetailTabs from '../views/PersonDetailTabs';
import InspectionDetailTabs from '../views/InspectionDetailTabs';
import ViolationDetailTabs from '../views/ViolationDetailTabs';
import AppointmentDetailTabs from '../views/AppointmentDetailTabs';
import PrintDocuments from '../views/PrintDocuments';
import Calendar from '../views/Calendar';
import TimeSheet from '../views/TimeSheet';
import Citations from '../views/Citations';
import Inbox from 'src/views/Inbox';

export const BASE_URL = '/licensing';

export default [
    {
        path: BASE_URL + '/licenses',
        title: 'Licenses',
        isTopMenuItem: true,
        isLeftMenuItem: true,
        component: License,
    },
    {
        path: BASE_URL + '/printDocuments',
        title: 'Print Documents',
        isTopMenuItem: true,
        isLeftMenuItem: true,
        component: PrintDocuments,
    },
    {
        path: BASE_URL + '/license/:id/detail',
        title: 'Application Detail',
        isTopMenuItem: false,
        isLeftMenuItem: false,
        component: LicenseDetailTabs,
    },
    {
        path: BASE_URL + '/filters',
        title: 'filters',
        isTopMenuItem: false,
        isLeftMenuItem: false,
        component: LicenseFilters,
    },
    {
        path: BASE_URL + '/person/:id/detail',
        title: 'Person',
        isTopMenuItem: false,
        isLeftMenuItem: false,
        component: PersonDetailTabs,
    },
    {
        path: BASE_URL + '/inspection/:id/detail',
        title: 'Inspection Details',
        isTopMenuItem: false,
        isLeftMenuItem: false,
        component: InspectionDetailTabs,
    },

    {
        path: BASE_URL + '/violation/:id/detail',
        title: 'Violation Details',
        isTopMenuItem: false,
        isLeftMenuItem: false,
        component: ViolationDetailTabs,
    },

    {
        path: BASE_URL + '/appointment/:id/detail',
        title: 'Appointment Details',
        isTopMenuItem: false,
        isLeftMenuItem: false,
        component: AppointmentDetailTabs,
    },

    {
        path: BASE_URL + '/calendar',
        title: 'Calendar',
        isTopMenuItem: true,
        isLeftMenuItem: true,
        component: Calendar,
    },
    {
        path: BASE_URL + '/inbox',
        title: 'Inbox',
        isTopMenuItem: true,
        isLeftMenuItem: true,
        component: Inbox,
    },
    {
        path: BASE_URL + '/timesheets',
        title: 'Time & Expense',
        isTopMenuItem: true,
        isLeftMenuItem: true,
        component: TimeSheet,
    },
    {
        path: BASE_URL + '/citations',
        title: 'Citations',
        isTopMenuItem: true,
        isLeftMenuItem: true,
        component: Citations,
    },
    {
        path: BASE_URL + '/citation/:id/detail',
        title: 'Citation Detail',
        isTopMenuItem: false,
        isLeftMenuItem: false,
        component: CitationDetailTabs,
    },
];
